export default __webpack_public_path__ + "static/media/ic_session_time.2eca1829.svg";